import HTTP from '@/utils/http'
import notification from '@/utils/notification'

const MODULE_PREFIX = '/departments'

export async function getDepartments (query) {
  try {
    const response = await HTTP.get(MODULE_PREFIX, {
      params: query,
    })
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err)
    return []
  }
}

export async function getDepartment (id, query) {
  try {
    const response = await HTTP.get(`${MODULE_PREFIX}/${id}`, {
      params: query,
    })
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err)
    return []
  }
}

export async function createDepartment (request) {
  try {
    const response = await HTTP.post(MODULE_PREFIX, request)
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err, 'department')
    throw err
  }
}

export async function updateDepartment (id, request) {
  try {
    await HTTP.put(`${MODULE_PREFIX}/${id}`, request)
    return true
  } catch (err) {
    notification.handleResponseError(err, 'department')
    throw err
  }
}

export async function getSitesByDepartmentId (id, query) {
  try {
    const response = await HTTP.get(`${MODULE_PREFIX}/${id}/sites`, {
      params: query,
    })
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err)
    return false
  }
}

export async function getUsersByDepartmentId (id, query) {
  try {
    const response = await HTTP.get(`${MODULE_PREFIX}/${id}/users`, {
      params: query,
    })
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err)
    return false
  }
}

export async function getSelectedSites (query) {
  try {
    const response = await HTTP.get(`${MODULE_PREFIX}/sites`, {
      params: query,
    })
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err)
    return false
  }
}

export async function getCategoriesByDepartment (query) {
  try {
    const response = await HTTP.get(`${MODULE_PREFIX}/categories`, { params: query })
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err)
    return {}
  }
}

export async function updateCategoryByDepartment (departmentId, request) {
  try {
    const response = await HTTP.put(`${MODULE_PREFIX}/${departmentId}/categories`, request)
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err)
    throw err
  }
}

export async function getBuildingsByDepartment (departmentId, user) {
  try {
    const response = await HTTP.get(`${MODULE_PREFIX}/${departmentId}/buildings`, { params: user })
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err)
    return {}
  }
}

/**
 * @param {string} site
 * @param {object} query
 * @returns {Promise<boolean>}
 */
export async function validateSite (site, query = {}) {
  try {
    const response = await HTTP.get(`${MODULE_PREFIX}/sites/${site}/ownship`, {
      params: query,
    })
    const { data } = response.data
    return data && data.isValid
  } catch (err) {
    notification.handleResponseError(err)
    return false
  }
}
